import Glide from "@glidejs/glide";
import { getElements, ifSelectorExist } from "./utils";

export const clixsySliders = () => {
  const videoSlider = getElements(".video-slider__slider");
  if (ifSelectorExist(videoSlider)) {
    Array.from(videoSlider).forEach((item) => {
      const glide = new Glide(item, {
        type: "carousel",
        gap: 15,
        focusAt: "center",
        animationDuration: 500,
        perView: 3,
        breakpoints: {
          1024: {
            perView: 1,
          },
        },
      });

      glide.mount();

      const bgImageContainer = item
        .closest(".video-slider-block")
        .querySelector(".bg-image-container");

      bgImageContainer.style.transition = "opacity 0.25s ease-in-out";

      const updateBackgroundImage = (activeSlide) => {
        const videoBgUrl = activeSlide
          .querySelector(".single_video__iframe")
          ?.getAttribute("poster");

        bgImageContainer.style.opacity = 0;

        setTimeout(() => {
          bgImageContainer.style.backgroundImage = `url('${videoBgUrl}')`;
          bgImageContainer.style.opacity = 0.5;
        }, 250);
      };

      const pauseAllVideos = () => {
        const iframes = item.querySelectorAll("iframe");
        const videos = item.querySelectorAll("video");

        videos.forEach((vid) => {
          if (!vid.paused) {
            vid.pause();
          }
        });

        iframes.forEach((iframe) => {
          const src = iframe.getAttribute("src");
          iframe.setAttribute("src", src);
        });
      };
      glide.on("run.after", () => {
        pauseAllVideos();
      })

      glide.on("move.after", () => {
        const activeSlide = item.querySelector(".glide__slide--active");
        updateBackgroundImage(activeSlide);
      });
    });
  }

  const reviewsSlider = getElements(".reviews-slider");
  if (ifSelectorExist(reviewsSlider)) {
    Array.from(reviewsSlider).forEach((item) => {
      const hasWhiteBackground = item.dataset.whiteBackground === "true";
      const glide = new Glide(item, {
        type: "carousel",
        gap: hasWhiteBackground ? 0 : 30,
        animationDuration: 500,
        perView: 3,
        breakpoints: {
          1200: {
            perView: 2,
            gap: hasWhiteBackground ? 0 : 15,
          },
          768: {
            perView: 1.5,
            gap: hasWhiteBackground ? 0 : 20,
          },
          540: {
            perView: 1.2,
            gap: hasWhiteBackground ? 0 : 20,
          },
        },
      });
      glide.mount();
    });
  }

  const amazonReviewsSlider = getElements(".amazon-reviews-slider");
  if (ifSelectorExist(amazonReviewsSlider)) {
    Array.from(amazonReviewsSlider).forEach((item) => {
      const glide = new Glide(item, {
        type: "carousel",
        gap: 0,
        animationDuration: 500,
        perView: 3,
        breakpoints: {
          1200: {
            perView: 2,
            gap: 0,
          },
          768: {
            perView: 1.5,
            gap: 0,
          },
          540: {
            perView: 1.2,
            gap: 0,
          },
        },
      });
      glide.mount();
    });
  }

  const quotesBlockMobileSlider = getElements(".quotes-block-mobile-slider");
  if (ifSelectorExist(quotesBlockMobileSlider)) {
    Array.from(quotesBlockMobileSlider).forEach((item) => {
      const glide = new Glide(item, {
        type: "carousel",
        gap: 0,
        animationDuration: 500,
        perView: 1,
      });
      glide.mount();
    });
  }

  const memberSlider = getElements(".member-block-slider");
  if (ifSelectorExist(memberSlider)) {
    Array.from(memberSlider).forEach((item) => {
      const glide = new Glide(item, {
        type: "carousel",
        gap: 30,
        animationDuration: 400,
        perView: 4,
        peek: { before: 0, after: -200 },
        focusAt: 0,
        breakpoints: {
          2400: {
            perView: 3,
          },
          2000: {
            perView: 3,
            peek: { before: 0, after: -300 },
          },
          1800: {
            perView: 2,
            peek: { before: 0, after: -100 },
          },
          1400: {
            perView: 2,
            peek: { before: 0, after: -200 },
          },
          992: {
            perView: 1,
            peek: 250,
            focusAt: "center",
          },
          850: {
            perView: 1,
            peek: 150,
            focusAt: "center",
          },
          570: {
            perView: 1,
            peek: 100,
            gap: 20,
            focusAt: "center",
          },
          420: {
            perView: 1,
            peek: 80,
            gap: 20,
            focusAt: "center",
          },
        },
      });
      glide.mount();
    });
  }
};
